// Central Kuwait governorates + areas dataset (editable in one place).
export const KUWAIT_GOVERNORATES = [
  {
    name: "العاصمة", en: "Capital",
    areas: ["الشويخ", "الشامية", "الروضة", "العديلية", "الخالدية", "قرطبة", "السرة", "اليرموك", "كيفان", "الدسمة", "الدعية", "المنصورية", "بنيد القار", "الدوحة", "النهضة", "جابر الأحمد", "شمال غرب الصليبيخات", "الصليبيخات", "الدوحة البحرية", "غرناطة", "الفيحاء", "النزهة", "عبدالله السالم", "القادسية", "المرقاب", "شرق", "الصوابر", "ضاحية عبدالله السالم", "مدينة الكويت"],
  },
  {
    name: "حولي", en: "Hawalli",
    areas: ["حولي", "السالمية", "الرميثية", "الجابرية", "بيان", "مشرف", "سلوى", "الشعب", "ميدان حولي", "النقرة", "حطين", "الزهراء", "السلام", "الشهداء", "الصديق", "مبارك العبدالله (غرب مشرف)", "البدع", "المسيلة", "الرميثية البحرية"],
  },
  {
    name: "الفروانية", en: "Farwaniya",
    areas: ["الفروانية", "خيطان", "جليب الشيوخ", "العارضية", "الرابية", "الأندلس", "الرقعي", "الفردوس", "العمرية", "إشبيلية", "الرحاب", "الضجيج", "عبدالله المبارك", "غرب عبدالله المبارك", "جنوب عبدالله المبارك", "صباح الناصر", "الرگعي", "غرناطة الفروانية"],
  },
  {
    name: "مبارك الكبير", en: "Mubarak Al-Kabeer",
    areas: ["مبارك الكبير", "القرين", "العدان", "القصور", "صباح السالم", "المسيلة", "أبو الحصانية", "الفنيطيس", "المسايل", "غرب أبو فطيرة", "أبو فطيرة", "جنوب سعد العبدالله (المنطقة الحرفية)", "صبحان الصناعية"],
  },
  {
    name: "الأحمدي", en: "Ahmadi",
    areas: ["الأحمدي", "الفحيحيل", "المنقف", "أبو حليفة", "المهبولة", "الرقة", "هدية", "الصباحية", "الفنطاس", "العقيلة", "ضاحية علي صباح السالم", "المقوع", "الوفرة", "الظهر", "الخيران", "صباح الأحمد", "مدينة صباح الأحمد البحرية", "جابر العلي", "فهد الأحمد", "الجليعة", "بنيدر", "الزور", "ميناء عبدالله"],
  },
  {
    name: "الجهراء", en: "Jahra",
    areas: ["الجهراء", "القصر", "الواحة", "النعيم", "النسيم", "العيون", "تيماء", "الصليبية", "أمغرة", "كبد", "الصبية", "العبدلي", "الروضتين", "الرقعي الزراعية", "مدينة المطلاع", "جنوب سعد العبدالله", "سعد العبدالله", "الجهراء الجديدة", "بر الجهراء"],
  },
];

export const COUNTRY_EN = { KW: "Kuwait", SA: "Saudi Arabia", AE: "United Arab Emirates", QA: "Qatar", BH: "Bahrain", OM: "Oman" };
